export default __webpack_public_path__ + "static/media/fur-coat.9b3a153a.png";